<div class="flex h-screen w-full overflow-hidden bg-slate-50">

  <div class="relative hidden md:flex w-1/2 items-center justify-center bg-slate-900 text-white overflow-hidden">
    
    <div class="absolute inset-0 z-0">
      <div class="absolute inset-0 bg-gradient-to-br from-blue-600 via-slate-900 to-slate-950 opacity-90"></div>
      <div class="absolute inset-0 opacity-20"
           style="background-image: radial-gradient(#ffffff 0.5px, transparent 0.5px); background-size: 20px 20px;">
      </div>
    </div>

    <div class="z-20 w-full max-w-2xl px-8 flex flex-col items-center">
      <div class="mb-12 text-center">
         <div class="flex items-center justify-center overflow-hidden" style="    width: 42%;
    justify-self: center;">
            <img src="assets/logo-light.png" alt="Alemidia Logo" class="object-cover object-center">
        </div>

        <p class="mt-4 text-xl text-blue-100 font-medium italic tracking-wide">
          Sua marca em movimento, sua estratégia sob controle.
        </p>
      </div>

      <div class="w-full max-w-md backdrop-blur-md bg-white/5 rounded-[2rem] p-8 border border-white/10 shadow-2xl">
        <p-carousel [value]="carouselItems" [numVisible]="1" [numScroll]="1" [circular]="true" autoplayInterval="5000" [showIndicators]="true">
          <ng-template let-item pTemplate="item">
            <div class="w-full flex flex-col items-center justify-center gap-3 py-2 animate-fade-in">
               
               <i [class]="item.icon" class="text-5xl text-sky-400 mb-2"></i>
               
               <h3 class="text-lg font-bold text-white tracking-wide">{{ item.title }}</h3>
               
               <p class="text-center text-sm font-light text-slate-200 px-2 leading-relaxed">
                 {{ item.text }}
               </p>

            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>

  <div class="w-full md:w-1/2 flex items-center justify-center p-8 bg-white relative">
    
    <div class="absolute top-0 right-0 w-64 h-64 bg-blue-50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 opacity-50"></div>

    <div class="w-full max-w-md bg-white p-10 relative z-10">

      <div class="mb-10 text-center">
            <div class="flex items-center justify-center overflow-hidden" style="    width: 42%;
    justify-self: center;">
            <img src="assets/logo-light.png" alt="Alemidia Logo" class="object-cover object-center">
        </div>
        
        <h2 class="text-2xl font-bold text-slate-800">Acesse sua conta</h2>
        <p class="text-slate-500 text-sm mt-1">Gerenciador de Marketing & Performance</p>
      </div>

      <form class="space-y-6" [formGroup]="form" (ngSubmit)="sendLogin()">

        <div class="flex flex-col space-y-1.5">
          <label for="email" class="text-xs font-bold uppercase tracking-wider text-slate-500">E-mail</label>
          <input pInputText id="email" type="email" formControlName="email"
                 class="w-full p-3.5 border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none"
                 placeholder="nome@alemidia.com.br"/>
        </div>

        <div class="flex flex-col space-y-1.5">
          <label for="password" class="text-xs font-bold uppercase tracking-wider text-slate-500">Senha</label>
          <p-password formControlName="password" [toggleMask]="true" [feedback]="false"
                      styleClass="w-full" 
                      inputStyleClass="w-full p-3.5 border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none"
                      placeholder="••••••••">
          </p-password>
        </div>

        <div class="flex items-center justify-between py-2">
          <div class="flex items-center">
            <p-checkbox inputId="remember" [binary]="true" formControlName="rememberMe" styleClass="checkbox-blue"></p-checkbox>
            <label for="remember" class="ml-2 cursor-pointer text-xs text-slate-500 hover:text-slate-700">Lembrar acesso</label>
          </div>
          <a (click)="showForgotPassword()" class="text-xs font-bold text-blue-600 hover:text-blue-800 transition-colors cursor-pointer">
            Esqueceu a senha?
          </a>
        </div>

        <button type="submit" 
                [disabled]="form.invalid"
                class="w-full bg-slate-900 hover:bg-blue-700 text-white font-bold py-4 rounded-xl transition-all duration-300 flex items-center justify-center gap-2 group disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-blue-900/10 cursor-pointer">
          <span *ngIf="!loading">ENTRAR</span>
          <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>
          <i *ngIf="!loading" class="pi pi-arrow-right group-hover:translate-x-1 transition-transform"></i>
        </button>
      </form>

      <div class="mt-12 text-center border-t border-slate-100 pt-6">
        <p class="text-[10px] text-slate-400 uppercase tracking-widest font-semibold">
          &copy; 2026 Alemidia Tech
        </p>
      </div>

    </div>
  </div>
</div>